// extracted by mini-css-extract-plugin
export default {"cls1":"ProfileList-cls1_QEk","cls2":"ProfileList-cls2_ypj ProfileList-cls1_QEk"};